import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { SectionComponent } from '../../components/section/section.component';

import { imageToPicture } from '../../components/plain-image/plain-image.component';
import { AspectRatio } from '@knorr-bremse-portals/ngx-components';
import { EditorIdDirective } from '../../directives/editor-id.directive';
import { Section, SectionAttributes } from '../../types/section';
import { VisualOverlayFigureSection, VisualOverlayedFigureComponent } from '../../components/visual-overlayed-figure/visual-overlayed-figure.component';
import { iconDownload, iconBrakeshoeLeft, iconBrakeshoeRight } from '@knorr-bremse-portals/icons';
import { IconComponent } from '@knorr-bremse-portals/ngx-components/components/icon';
import { GalleryComponent, provideGalleryIntl } from '@knorr-bremse-portals/ngx-components/components/gallery';
import { LocalGalleryIntl } from '../../providers/intl/gallery.intl';
import { FsButtonComponent } from '../../components/fs-button/fs-button.component';
import { VisualFigureSection, VisualFigureComponent } from '../../components/visual-figure/visual-figure.component';

type StageVisualsAttributes = {
  visuals: VisualOverlayFigureSection[];
  images?: VisualOverlayFigureSection[]; // for backwards compatibility
  mode?: 'stage' | 'overlay';
}

type NormalVisualsAttributes = {
  visuals: VisualFigureSection[];
  images?: VisualFigureSection[]; // for backwards compatibility
  mode: 'normal';
}

type VisualsAttributes = {
  numColumns: 8 | 12;
  headline?: string;
} & SectionAttributes & (StageVisualsAttributes | NormalVisualsAttributes);

type VisualsSection = Section<
  VisualsAttributes,
  [
    'headline',
  ],
  'visuals'
>;

@Component({
    selector: 'section[app-visuals]',
    styleUrls: ['./visuals.component.scss'],
    templateUrl: './visuals.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        EditorIdDirective,
        IconComponent,
        GalleryComponent,
        VisualOverlayedFigureComponent,
        FsButtonComponent,
        VisualFigureComponent,
    ],
    providers: [
        provideGalleryIntl(LocalGalleryIntl),
    ],
})
export class VisualsComponent extends SectionComponent<VisualsSection> implements OnInit {

  protected imageToPicture = imageToPicture;
  protected aspectRatio = AspectRatio.Standard;
  protected iconDownload = iconDownload;
  protected iconBrakeshoeLeft = iconBrakeshoeLeft;
  protected iconBrakeshoeRight = iconBrakeshoeRight;

  public override ngOnInit(): void {
    super.ngOnInit();

    // This is here to ensure backwards compatibility with the old image-gallery component
    if (this.attributes.visuals === undefined && this.attributes.images) {
      this.attributes.visuals = this.attributes.images
    }
  }

}
